import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/focusStyles.css.ts", "@paypalcorp/pp-react-utils");
import { tokens } from '@paypalcorp/pp-react-theme';
import { style as _style } from '@vanilla-extract/css';
function style(rule, debugId) {
  return [_style(rule, debugId), rule];
}
const stateFocusBorderWidthInner = `calc(${tokens.border.thickness.normal} + ${tokens.border.thickness.emphasis})`;
const stateFocusBorderWidthOuter = `calc(2*${stateFocusBorderWidthInner})`;
const boxShadowColor = tokens.color.structure.focusOutline;
const topPos = 0;
const leftPos = 0;
const rightPos = 0;
const radius = 'inherit';
const widthOffset = `calc(${tokens.border.thickness.normal} * 2)`;
const heightOffset = `calc(${tokens.border.thickness.normal} * 2)`;
const borderWidth = `calc(${stateFocusBorderWidthInner} + ${stateFocusBorderWidthInner})`;
const focusInlineBorderThickness = `calc(${tokens.border.thickness.emphasis} + ${tokens.border.thickness.emphasis})`;
export const [focusAfter, focusAfterStyles] = style({
  content: '',
  position: 'absolute',
  top: topPos,
  left: leftPos,
  right: rightPos,
  border: 'none',
  boxShadow: `0 0 0 ${stateFocusBorderWidthOuter} ${boxShadowColor}`,
  borderRadius: radius,
  width: '100%',
  height: '100%',
  pointerEvents: 'none'
}, 'focus_after');
export const [offsetFocusAfter, offsetFocusAfterStyles] = style({
  content: '',
  position: 'absolute',
  top: tokens.border.thickness.normal,
  left: tokens.border.thickness.normal,
  border: `${stateFocusBorderWidthInner} solid ${tokens.color.structure.focus}`,
  boxShadow: `0 0 0 ${stateFocusBorderWidthOuter} ${boxShadowColor}`,
  borderRadius: 'inherit',
  textIndent: tokens.border.thickness.normal,
  width: `calc(100% - ${widthOffset})`,
  height: `calc(100% - ${heightOffset})`,
  pointerEvents: 'none'
}, 'offset_focus_after');
export const [focusInline, focusInlineStyles] = style({
  boxShadow: `0 0 0 ${stateFocusBorderWidthInner} ${tokens.color.structure.focus},
    0 0 0 ${borderWidth} ${tokens.color.structure.focusOutline}`,
  outline: `${stateFocusBorderWidthInner} solid transparent`,
  borderRadius: 'inherit'
}, 'focus_inline');
export const [focusOffsetElement, focusOffsetElementStyles] = style({
  outline: `${tokens.border.thickness.emphasis} solid ${tokens.color.structure.focus}`,
  boxShadow: `0 0 0 ${tokens.border.thickness.emphasis} ${tokens.color.background.surface}`,
  outlineOffset: tokens.border.thickness.emphasis
}, 'focus_offset_element');
export const [focusInlineElement, focusInlineElementStyles] = style({
  outline: `${tokens.border.thickness.emphasis} solid ${tokens.color.structure.focus}`,
  boxShadow: `0 0 0 ${focusInlineBorderThickness} inset ${tokens.color.background.surface}`,
  outlineOffset: `calc(${tokens.border.thickness.emphasis}*-1)`
}, 'focus_inline_element');
__vanilla_filescope__.endFileScope();
